module.exports = __webpack_public_path__ + "img/sec15desk.55938f10.png";